//--------------------- Web Analyse -------------------------//
export enum TRACKER_TYPE {
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
  E3 = 'E3',
  E4 = 'E4',
}

export enum FIELDS_ERROR {
  NO_ERROR = 0, // 0 => no error
  NOT_FILLED = 1, // 1 => field not filled
  NOT_SELECTED = 2, // 2 => field not selected
  INVALID_FORMAT = 3, // 3 => invalid format
}

//--------------------- App -------------------------//

export enum Storage {
  STORE_PP = 'store-pp',
  CONTEXT_PP = 'context-pp',
}

export enum LoadingStatus {
  LOADING = 'LOADING',
  SAVING = 'SAVING',
  END_ACTION = 'END',
}

export enum GeoLoc {
  CTLM = 'CTLM',
  CMAG = 'CMAG',
  CMOI = 'CMOI',
  NONE = 'NONE',
}

export enum Domain {
  CTLM = 'cetelem.fr',
  CM = 'credit-moderne.com',
  LOCAL = 'localhost',
}

export enum LogementStatus {
  LOCATAIRE = 'L',
  PROPRIETAIRE = 'P',
  AUTRE = 'A',
  LOGE = 'F',
}

export enum ModalStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}
